import * as React from "react";

import { cn } from "../lib/cn";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-[var(--color-border)] bg-app-background px-3 py-2 type-body-s-regular ring-offset-white file:border-0 file:bg-transparent file:type-body-s-regular placeholder:text-neutral-500 focus-visible:outline-hidden focus-visible:border-2 focus-visible:border-[var(--focus-border)] focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 dark:ring-offset-neutral-950 dark:placeholder:text-neutral-400",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
